import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
    environment: process.env.NODE_ENV,
    // Ignore known noise from 3rd-party scripts we don't control
    ignoreErrors: [
      "Unexpected token .",           // Cloudflare beacon.min.js parse failure on old browsers
      /beacon\.min\.js/i,             // Any error from Cloudflare Web Analytics beacon
      /fbevents\.js/i,                // Meta Pixel loader (Meta's own errors)
      /gtag|google-analytics/i,       // GA errors (not our code)
      /ResizeObserver loop/i,         // Benign browser quirk, no user impact
      /Non-Error promise rejection/i, // Meaningless catch-all rejections
      /Java object is gone/i,         // Instagram/Facebook in-app browser (IAB) webview bridge quirk on Android
      /navigation_performance_logger/i, // Instagram in-app browser's own perf logger
      /iabjs:\/\//i,                  // Instagram in-app browser script origin
    ],
    denyUrls: [
      /\/beacon\.min\.js/i,
      /connect\.facebook\.net/i,
      /www\.googletagmanager\.com/i,
      /\/emergent-main\.js/i,         // Emergent platform script
      /^iabjs:\/\//i,                 // Instagram in-app browser injected scripts
    ],
    beforeSend(event, hint) {
      const filename = hint?.originalException?.filename || event?.exception?.values?.[0]?.stacktrace?.frames?.[0]?.filename || "";
      // Drop anything originating from 3rd-party scripts even if it slipped past ignoreErrors
      if (/beacon\.min\.js|fbevents|facebook\.net|googletagmanager|gtag|emergent-main|iabjs:\/\/|navigation_performance_logger/i.test(filename)) {
        return null;
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding:40,color:"#fff",background:"#0F1117",minHeight:"100vh"}}>Something went wrong. Our team has been notified.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
